import React, {useState, useEffect, useRef, useCallback} from "react";
import MaskedInput from "react-text-mask";
import { NumericFormat } from "react-number-format";
import FloatingLabelStyle from "./FloatingLabel.module.scss";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./FloatingLabel.scss";
import CustomTimeInput from "components/CustomTimeInput";
// Static image path from public folder
const JMDIcon = "/assets/img/payment_form_icons/JMD.svg"; 

const FloatingLabelInput = ({
	as: Component = "input",
	inputType = "",
	id,
	label=undefined,
	labelBackgroundColor="linear-gradient(rgb(255 255 255) 0%, rgb(255 255 255) 55%, rgb(255 255 255 / 0%) 45%, rgb(255 255 255 / 0%) 100%)",
	type = "text",
	country,
	onChange,
	onBlur,
	placeholder = " ",
	mask,
	error="",
	showErrorMessage = true,
	touched,
	guide = false,
	value,
	inputHighlight = false,
	leftIcon = null,
	rightIcon = null,
	errorStyle = "inline",
	setField = undefined,
	editFunction = undefined,
	editable = undefined,
	bypassTouch = false,
	timePicker = undefined,
	setTimePicker = undefined,
	setOpenTimeSelector = undefined, 
	openTimeSelecter = undefined,
	customBlur = undefined,
	date,
	validateTimePicker,
	showLabel=true,
	onClickTimePicker = undefined,
	enableSpeechToText = true,
	...inputProps
}) => {
	const WrapperComponent = mask && inputType === "mask" ? MaskedInput :
		inputType === "currency" || inputType === "currency-input-dropdown" ? NumericFormat :
		inputType === "country" ? CountryDropdown  :
		inputType === "region" ? RegionDropdown  : 
		inputType === "datePicker" ? DatePicker : 
		inputType === "timePicker" ? CustomTimeInput : Component;

 
	// currencyList.js
	const currencies = [
		{ code: 'JMD', label: 'Jamaican Dollar', symbol: 'J$' },
		{ code: 'USD', label: 'US Dollar', symbol: '$' },
		{ code: 'EUR', label: 'Euro', symbol: '€' },
		{ code: 'GBP', label: 'British Pound', symbol: '£' },
		{ code: 'JPY', label: 'Japanese Yen', symbol: '¥' },
	];
	const [buttonState, setButtonState] = useState(false);
	const [selectedCurrency, setSelectedCurrency] = useState('');
	const [ voiceInput, setVoiceInput] = useState('');
	const inputRef = useRef(null)
	const recognitionRef = useRef(null); 
	
	//enable speach to text for textarea by default
	enableSpeechToText = Component === "textarea" && enableSpeechToText !== false;

	const setProgrammatically = (value) => {
		const input = inputRef.current;
		if (!input) return;
 
		// React listens on 'input', not 'change'
		if(input?.tagName === "TEXTAREA"){
			const descriptor = Object.getOwnPropertyDescriptor(
				HTMLTextAreaElement.prototype, 'value'
			);
			const nativeSetter = descriptor && descriptor.set;
			if (!nativeSetter) return;

			nativeSetter.call(input, value);
 		 	input.dispatchEvent(new Event('input', { bubbles: true }));
		} else {
			const descriptor = Object.getOwnPropertyDescriptor(
				HTMLInputElement.prototype, 'value'
			);
			const nativeSetter = descriptor && descriptor.set;
			if (!nativeSetter) return;

			nativeSetter.call(input, value);
			input.dispatchEvent(new Event('input', { bubbles: true }));
		} 
	};

	useEffect(() => {
		const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
		if (!SpeechRecognition) return;

		const recognition = new SpeechRecognition();
		recognition.continuous = true;
		recognition.lang = "en-US";


		recognition.onresult = event => {
			const transcript = event.results[event.results.length - 1][0].transcript;
			setVoiceInput(prev => {
				if(prev){
					setProgrammatically(prev + " " + transcript);
					return prev + " " + transcript;
				} else {
					setProgrammatically(transcript);
					return transcript;
				} 
			});
			// if (isTheftFlow) {
			// 	setTheftCircumstances(prev => (prev ? prev + " " + transcript : transcript));
			// } else {
			// 	setValue(prev => (prev ? prev + " " + transcript : transcript));
			// }
			// now onChange will fire
		};

		// recognition.onerror = event => {
		// 	warn("Speech recognition error:", event.error);
		// };

		recognitionRef.current = recognition;

		return () => recognition.abort();
	}, []);

	const startListening = useCallback(() => { 
		recognitionRef.current?.start();
	}, []);

	const stopListening = useCallback(() => {
		recognitionRef.current?.stop();
	}, []);

	useEffect(()=>{
		const handleClickOutside = (e) => {
			if (!e.target.closest(".speech-to-text")){
				setButtonState(false);
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	useEffect(() => {
		try {
			buttonState ? startListening() : stopListening();
		} catch (e) {
			warn("Speech recognition error:", e);
		}
	}, [buttonState, startListening, stopListening]);



	const showError = error && (touched || bypassTouch);

	const hasRenderableIcon = icon => icon !== null && icon !== undefined && icon !== "" && icon !== false;
	const hasLeftIcon = hasRenderableIcon(leftIcon);
	const hasRightIcon = hasRenderableIcon(rightIcon);
 
	return (
		<>
		<div 
			tabIndex={0}
			onBlur={ customBlur != undefined ? customBlur : ()=>{} }
			className={`${FloatingLabelStyle.outlinedInputContainer} ${FloatingLabelStyle.customFormField} ${showError ? FloatingLabelStyle.isInvalid : ""} ${hasLeftIcon ? FloatingLabelStyle.hasLeftIcon : ""} ${hasRightIcon ? FloatingLabelStyle.hasRightIcon : ""}`} style={{ marginBottom: 10, minHeight: "80px", paddingBottom: error && touched ? "0" : "0px"}}
		>

			{showLabel ? <label htmlFor={id} className={`${FloatingLabelStyle.outlinedLabel} ${hasLeftIcon ? FloatingLabelStyle.labelWithLeftIcon : ""}`} style={{ color: inputProps.disabled === true ? "#858585" : "#006485", background: "linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 44%, rgb(255, 255, 255) 45%, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0) 54%)" }}>
				{label}
			</label> : null}

			<div className={`${inputProps.className?.includes("textarea") ? `${FloatingLabelStyle.outlinedInput} ${FloatingLabelStyle.textarea}` : FloatingLabelStyle.inputWrapper} ${!error && value || date ? FloatingLabelStyle.hasValue : ""}`}>
				{hasLeftIcon && (
					<span className={FloatingLabelStyle.leftIcon}>
						{leftIcon}
					</span>
				)}
				{inputType === "currency-input-dropdown" && (
					<span className={FloatingLabelStyle.currencyIcon}>
						<img src={JMDIcon} alt="JMD" style={{ width: 26, height: 26 }} />
					</span>
				)}
				<WrapperComponent
					ref={ inputProps?.ref == null || inputProps?.ref == undefined || enableSpeechToText ? inputRef : inputProps?.ref }
					id={id}
					name={id}
					type={type}
					value={(inputType === "currency" || inputType === "currency-input-dropdown") && (value === '' || value === '0.00' || value === '0') ? null : value}
					{...(inputType !== "currency" && inputType !== "currency-input-dropdown" ? { onChange } : {})}
					onBlur={onBlur}
					placeholder={placeholder}
					{...(mask && Component === "input" ? { mask, guide } : {})}
					{...(inputType === "currency" || inputType === "currency-input-dropdown" ? {
						thousandSeparator: true,
						decimalScale: 2,
						// Only apply fixedDecimalScale when there's a non-zero value to prevent showing "0.00" on empty
						fixedDecimalScale: !!(value && value !== '' && parseFloat(String(value).replace(/,/g, '')) > 0),
						allowNegative: false,
						prefix: inputProps.hideCurrencyPrefix ? '' : '$',
						onValueChange: (values) => {
							// Store the formatted value without the $ prefix (e.g., "2,000.00")
							const formattedWithoutPrefix = values.formattedValue?.replace(/^\$/, '') || '';
							const syntheticEvent = {
								target: {
									name: id,
									value: formattedWithoutPrefix
								}
							};
							if (onChange) onChange(syntheticEvent);
						}
					} : {})}
					{...(inputType === "datePicker" ? {
						dateFormat: "MM/dd/yyyy",
						placeholderText: placeholder,
						showYearDropdown: true,
						showMonthDropdown: true,
						maxDate: new Date,
						selectsStart: true
					} : {})}
					{...(inputType === "timePicker" ? {  
						date: timePicker,
						onClickTimePicker: onClickTimePicker,
						onChange: setTimePicker, 
						setOpenTimeSelector: setOpenTimeSelector, 
						openTimeSelecter: openTimeSelecter,
						validateTimePicker: validateTimePicker,
						className: `${FloatingLabelStyle.outlinedInput} ${inputHighlight ? `${FloatingLabelStyle.borderHighlight}` : ""} ${inputType === "currency-input-dropdown" ? `${FloatingLabelStyle.currencyInputDropdown}` : ""} ${hasLeftIcon ? FloatingLabelStyle.inputWithLeftIcon : ""} ${hasRightIcon ? FloatingLabelStyle.inputWithRightIcon : ""} ${inputProps.className?.includes("textarea") ? `${FloatingLabelStyle.textarea} ${FloatingLabelStyle.noRadius} border border-0 px-1` : inputProps.className || ""}`
					} : {})}
					{...inputProps}
					className={`${FloatingLabelStyle.outlinedInput} ${inputHighlight ? `${FloatingLabelStyle.borderHighlight}` : ""} ${inputType === "currency-input-dropdown" ? `${FloatingLabelStyle.currencyInputDropdown}` : ""} ${hasLeftIcon ? FloatingLabelStyle.inputWithLeftIcon : ""} ${hasRightIcon ? FloatingLabelStyle.inputWithRightIcon : ""} ${inputProps.className?.includes("textarea") ? `${FloatingLabelStyle.textarea} ${FloatingLabelStyle.noRadius} border border-0 px-1` : inputProps.className || ""}`}
				/>
				{hasRightIcon && (
					<span 
					 	onClick={() => {
							if (editable && editFunction) editFunction();
						}}
					 className={FloatingLabelStyle.rightIcon}>
						{rightIcon}
					</span>
				)}
				{(enableSpeechToText && !hasRightIcon) && (
				<div
					className={`speech-to-text ${buttonState ? "activated" : ""}`}
					onClick={() => {
						setButtonState(prev => !prev);
					}}
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
						<path d="M320 64C267 64 224 107 224 160L224 288C224 341 267 384 320 384C373 384 416 341 416 288L416 160C416 107 373 64 320 64zM176 248C176 234.7 165.3 224 152 224C138.7 224 128 234.7 128 248L128 288C128 385.9 201.3 466.7 296 478.5L296 528L248 528C234.7 528 224 538.7 224 552C224 565.3 234.7 576 248 576L392 576C405.3 576 416 565.3 416 552C416 538.7 405.3 528 392 528L344 528L344 478.5C438.7 466.7 512 385.9 512 288L512 248C512 234.7 501.3 224 488 224C474.7 224 464 234.7 464 248L464 288C464 367.5 399.5 432 320 432C240.5 432 176 367.5 176 288L176 248z" />
					</svg>
				</div>)}
			</div> 
			{error && (touched || bypassTouch) && !inputHighlight && showErrorMessage &&(
				errorStyle === "tooltip" ? (
					<div className={FloatingLabelStyle.errorTooltip}>
						<span className={FloatingLabelStyle.errorIcon}>⚠</span>
						<span>{error}</span>
					</div>
				) : (
					<div className={FloatingLabelStyle.errorText} style={{ minHeight: 18 }}>
						<span>{error}</span>
					</div>
				)
			)}

		</div>

		</>
	);
};

export default FloatingLabelInput;
